<template>
  <highcharts :options="chartOptions" ref="chart" />
</template>

<script>
import Highcharts from 'highcharts'
import moment from 'moment-timezone'

export default {
  props: {
    data: {},
    dateTimeFrom: null,
    dateTimeTo: null
  },
  data: function () {
    return {
      chartOptions: {
        chart: {
          zoomType: 'xy',
          resetZoomButton: {
            position: {
              x: 0,
              y: -10
            }
          },
          animation: false,
          height: 200,
          zooming: {
            mouseWheel: {
              enabled: true
            }
          },
          events: {
            load () {
              const chart = this

              // Block scroll wheel unless Shift is held
              chart._wheelBlocker = (e) => {
                if (!e.shiftKey) {
                  if (e.stopImmediatePropagation) e.stopImmediatePropagation()
                  e.stopPropagation()
                }
              }
              chart.container.addEventListener('wheel', chart._wheelBlocker, { capture: true })

              // Show zoom cursor when Shift is held
              chart._cursorHint = (e) => {
                chart.container.style.cursor = e.shiftKey ? 'zoom-in' : ''
              }
              chart.container.addEventListener('mousemove', chart._cursorHint)

              // Flip cursor immediately on Shift press/release
              chart._onKeyShift = (e) => {
                if (e.key === 'Shift' && chart.container) {
                  chart.container.style.cursor = (e.type === 'keydown') ? 'zoom-in' : ''
                }
              }
              chart._offKeyDown = Highcharts.addEvent(document, 'keydown', chart._onKeyShift)
              chart._offKeyUp = Highcharts.addEvent(document, 'keyup', chart._onKeyShift)
            },
            destroy () {
              const el = this.container
              if (this._wheelBlocker && el) el.removeEventListener('wheel', this._wheelBlocker, { capture: true })
              if (this._cursorHint && el) el.removeEventListener('mousemove', this._cursorHint)
              if (this._offKeyDown) this._offKeyDown()
              if (this._offKeyUp) this._offKeyUp()
            }
          }
        },
        credits: {
          enabled: false
        },
        accessibility: {
          enabled: false
        },
        title: false,
        plotOptions: {
          line: {
            marker: {
              enable: true
            }
          }
        },
        tooltip: {
          xDateFormat: '%Y-%m-%d %H:%M:%S',
          valueDecimals: 1,
          shared: true
        },
        yAxis: {
          title: false
        },
        xAxis: {
          title: {
            enabled: false
          },
          type: 'datetime',
          gridLineWidth: 1,
          dateTimeLabelFormats: {
            millisecond: '%H:%M:%S.%L',
            second: '%H:%M:%S',
            minute: '%H:%M',
            hour: '%H:%M',
            day: '%e %b \'%y',
            week: '%e %b \'%y',
            month: '%b \'%y',
            year: '%Y'
          }
        },
        series: []
      }
    }
  },
  created: function () {
    this.load()
    Highcharts.setOptions({
      global: {
        getTimezoneOffset: function (timestamp) {
          var zone = Intl.DateTimeFormat().resolvedOptions().timeZone
          var timezoneOffset = -moment.tz(timestamp, zone).utcOffset()
          return timezoneOffset
        }
      }
    })
  },
  methods: {
    load: function () {
      if (this.data === null || this.isEmpty(this.data)) {
        return
      }

      const unit = this.getUnit(Object.keys(this.data)[0])
      if (unit) {
        this.chartOptions.yAxis.labels = { format: '{value} ' + unit }
      }

      for (const [key, values] of Object.entries(this.data)) {
        const seriesData = []
        values.forEach(element => {
          seriesData.push([ moment(element.dt).valueOf(), parseFloat(element.val) ])
        })
        this.chartOptions.series.push({
          name: key,
          data: seriesData,
          tooltip: { valueSuffix: unit }
        })
      }
    },
    getUnit (key) {
      if (key.startsWith('deg')) {
        return '℃'
      }

      return null
    },
    isEmpty (value) {
      return value.constructor === Object && Object.keys(value).length === 0
    },
    clearChart () {
      while (this.$refs.chart.chart.series.length > 0) {
        this.$refs.chart.chart.series[0].remove(false)
      }
      this.chartOptions.series = []
      this.$refs.chart.chart.xAxis.min = []
      this.$refs.chart.chart.xAxis.max = []
      this.$refs.chart.chart.yAxis.min = []
      this.$refs.chart.chart.yAxis.max = []
      this.$refs.chart.chart.redraw()
    }
  },
  watch: {
    data: function () {
      this.clearChart()
      this.load()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/mixedSignals/_trend/_trendChart.vue